import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import HouseOfTao from "./components/Home/HouseOfTao";
import Home from "./components/Home/Home";
import OurSpaces from "./components/OurSpaces/OurSpaces";
import Test from "./components/Home/Test";
import HomePage from "./components/Home/HomePage";
import OurPhilosophy from "./components/OurPhilosophy/OurPhilosophy";
import OurServices from "./components/OurServices/OurServices";
import Details from "./components/Details/Details";
import BookNow from "./components/BookNow/BookNow";
import Confirmation from "./components/Confirmation/Confirmation";

function App() {
  return (
    <div>
      <Router>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/HouseOfTao" element={<HouseOfTao />} />
          <Route path="/Home" element={<Home />} />
          <Route path="/OurSpaces" element={<OurSpaces />} />
          <Route path="/HomePage" element={<HomePage />} />
          <Route path="/OurPhilosophy" element={<OurPhilosophy />} />
          <Route path="/OurServices" element={<OurServices />} />
          <Route path="/Details" element={<Details />} />
          <Route path="/BookNow" element={<BookNow />} />
          <Route path="/Confirmation" element={<Confirmation />} />

          <Route path="/Test" element={<Test />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
